import { compare } from '../../../../webmodule-common/other/clone';
import { emptyGuid } from '../../../../webmodule-common/other/api/guid';
import { getApiFactory } from '../../../api/api-injector';
import { ResultGetGeneratedPurchaseOrderRevenue } from '../../../api/supplier-api-interface-franchiseenetwork';

class GeneratedPurchaseOrdersCache {
  _pageKey = this.pageKey('', '-1', [], []);
  _pagePromise: Promise<ResultGetGeneratedPurchaseOrderRevenue | null> | null = null;
  pageKey(
    startDate: string,
    endDate: string,
    purchaseOrderStates: number[],
    branchIds: string[],
    userId?: string
  ): { startDate: string; endDate: string; purchaseOrderStates: number[]; branchIds: string[]; userId?: string } {
    return { startDate, endDate, purchaseOrderStates, branchIds, userId };
  }
  async getData(
    startDate: string,
    endDate: string,
    purchaseOrderStates: number[],
    branchIds: string[],
    userId?: string
  ) {
    const currentPage = this.pageKey(startDate, endDate, purchaseOrderStates, branchIds, userId);
    if (!compare(this._pageKey, currentPage)) {
      this._pageKey = currentPage;
      this._pagePromise = getApiFactory()
        .dataAggregation()
        .getGeneratedPurchaseOrderRevenue({
          startDate: startDate,
          endDate: endDate,
          states: purchaseOrderStates,
          branchIds: branchIds,
          assignedToUserId: userId ?? emptyGuid
        });
    }
    return await this._pagePromise;
  }
}

let _db: GeneratedPurchaseOrdersCache | null = null;
export function flushGeneratedPurchaseOrdersCache() {
  _db = null;
}
export function generatedPurchaseOrdersCache(): GeneratedPurchaseOrdersCache {
  if (!_db) {
    _db = new GeneratedPurchaseOrdersCache();
  }
  return _db;
}
